export default "__VITE_ASSET__BQrSc58w__"